class MobileMenuTabs {
  constructor(options) {
    this.options = Object.assign({ categoriesLabel: 'categories' }, options);

    // Rebuilds on every hamburger click rather than once-ever: Horizon
    // supports soft page transitions (data-page-transition-enabled), which
    // can swap in a freshly-rendered, untouched copy of the drawer markup
    // without a full page reload. A one-time "already initialized" flag
    // would incorrectly skip rebuilding that fresh copy, which is exactly
    // why Categories intermittently showed back up under the Menu tab —
    // it wasn't flaky, it was this specific gap. build() is idempotent
    // (checks for its own prior output before doing anything), so calling
    // it repeatedly is safe.
    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('.header__icon--menu');
      if (trigger) {
        requestAnimationFrame(() => this.build());
      }
    });

    // Also catch the case where Horizon's soft navigation replaces the
    // drawer while it's already open (no fresh hamburger click happens).
    const observer = new MutationObserver(() => {
      const nav = document.querySelector('.menu-drawer__navigation');
      if (nav && !nav.querySelector('.mobile-menu-tabs')) {
        this.build();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  build() {
    const nav = document.querySelector('.menu-drawer__navigation');
    if (!nav) return;

    // Idempotency guard: if this specific nav element already has a tab
    // bar, it's already been built — do nothing. This replaces the old
    // permanent "this.initialized" flag, which blocked rebuilding a *new*
    // nav element that appears after a soft navigation.
    if (nav.querySelector('.mobile-menu-tabs')) return;

    const topList = nav.querySelector('ul.menu-drawer__menu.has-submenu');
    if (!topList) return;

    // Find the top-level link whose text matches the configured label
    // (default "Categories"), the same text-matching approach used for
    // the desktop mega menu, since this markup has no unique id/data
    // attribute distinguishing one nested childlist from another.
    const mainLinks = topList.querySelectorAll(':scope > li > a.menu-drawer__menu-item--mainlist');
    let categoriesLink = null;
    mainLinks.forEach((link) => {
      const text = (link.textContent || '').trim().toLowerCase();
      if (text === this.options.categoriesLabel) categoriesLink = link;
    });
    if (!categoriesLink) return;

    const categoriesListItem = categoriesLink.closest('li');
    const categoriesChildList = categoriesListItem.querySelector('ul.menu-drawer__menu--childlist');
    if (!categoriesChildList) return;

    // Build the tab bar
    const tabBar = document.createElement('div');
    tabBar.className = 'mobile-menu-tabs';
    tabBar.innerHTML = `
      <button type="button" class="mobile-menu-tabs__btn is-active" data-tab="menu">Menu</button>
      <button type="button" class="mobile-menu-tabs__btn" data-tab="categories">Categories</button>
    `;
    nav.insertBefore(tabBar, topList);

    // Move the Categories childlist out of the flat list into its own
    // panel, and drop the now-redundant "Categories" row from the Menu
    // tab (it has its own dedicated tab now, showing it twice would be
    // confusing).
    const categoriesPanel = document.createElement('div');
    categoriesPanel.className = 'mobile-menu-tabs__panel mobile-menu-tabs__panel--categories';
    categoriesPanel.appendChild(categoriesChildList);
    nav.insertBefore(categoriesPanel, topList.nextSibling);
    categoriesListItem.remove();

    topList.classList.add('mobile-menu-tabs__panel', 'mobile-menu-tabs__panel--menu');

    tabBar.addEventListener('click', (e) => {
      const btn = e.target.closest('.mobile-menu-tabs__btn');
      if (!btn) return;

      tabBar.querySelectorAll('.mobile-menu-tabs__btn').forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const showCategories = btn.dataset.tab === 'categories';
      topList.classList.toggle('is-hidden-tab', showCategories);
      categoriesPanel.classList.toggle('is-hidden-tab', !showCategories);
    });
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new MobileMenuTabs({ categoriesLabel: 'categories' });
});
